import { TypeResponse } from 'gtd-ng-widget';

export class LastStepResponse extends TypeResponse {
  data: {
    id: number;
    name: string;
    order: number;
    description: string;
    type: string;
    approved_mode: string;
    settings: string;
    created_at: number;
    updated_at: number;
    affiliate_id: number;
    process: string;
    state: number;
    affiliate_step_id: number;
    declined_reason: string | null;
  };
}
